import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';

import MobileYieldTable from './MobileYieldTable';
import DisclaimerBox from './DisclaimerBox';
import DesktopYieldTable from './DesktopYieldTable';

const Title = styled(Typography)`
  font-size: 30px;
  line-height: 36px;
  letter-spacing: -0.03em;
  text-align: left;
  font-weight: 500;

  @media (width >= 768px) {
    font-size: 44px;
    line-height: 48.4px;
    text-align: center;
  }

  span {
    color: #7B4DD6;
  }
`;

const Transparency = () => (
  <Box
    tag="section"
    marginTop={{ xs: '32px', lg: '64px' }}
    marginBottom={{ xs: '60px', lg: '64px' }}
    paddingHorizontal={{ xs: '48px', md: '128px', lg: '100px' }}
  >
    <Title strong whiteSpace={{ xs: 'pre-line', lg: 'normal' }}>
      {'Te damos \n transparencia y \n'}
      <span>claridad</span>
    </Title>

    <MobileYieldTable />
    <DesktopYieldTable />
    <DisclaimerBox />
  </Box>

);

export default Transparency;
